export default "__VITE_ASSET__BruBM4c7__"